import {
  ADD_MODULE,
  SET_ACTIVE_MODULE,
  SWITCH_CONFIG,
  REMOVE_CONFIG,
  DELETE_MODULE,
  SET_UPDATE,
  COMPONENT_SORT_CHANGE,
} from '../constants/index'
import util from '../../utils/utils'

export const addModule = (render: string, pid = 'root') => {
  return {
    type: ADD_MODULE,
    id: `${render}_${util.generateUUID().substring(0, 7)}`,
    render,
    pid: pid || 'root',
  }
}

export const setActiveModule = (id: string, pid: string, render: string) => ({
  type: SET_ACTIVE_MODULE,
  id,
  pid,
  render,
})

export const switchConfig = (activeKey: string) => ({
  type: SWITCH_CONFIG,
  activeKey,
})

export const removeConfig = (key: string) => ({
  type: REMOVE_CONFIG,
  key,
})

export const deleteModule = (id: string, pid: string) => ({
  type: DELETE_MODULE,
  id,
  pid,
})

export const setUpdate = (isUpdate: boolean) => ({
  type: SET_UPDATE,
  isUpdate,
})
export const componentSort = (pid: string, index: number, isUp: boolean) => ({
  type: COMPONENT_SORT_CHANGE,
  pid,
  index,
  isUp,
})
